import React from 'react';

export default function IconSettingHelp() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_652_337)">
        <path
          d="M9 14.8333C12.2217 14.8333 14.8333 12.2217 14.8333 8.99999C14.8333 5.77833 12.2217 3.16666 9 3.16666C5.77834 3.16666 3.16666 5.77833 3.16666 8.99999C3.16666 12.2217 5.77834 14.8333 9 14.8333Z"
          stroke="currentColor"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9 11.9167C10.6108 11.9167 11.9167 10.6108 11.9167 9.00001C11.9167 7.38918 10.6108 6.08334 9 6.08334C7.38917 6.08334 6.08334 7.38918 6.08334 9.00001C6.08334 10.6108 7.38917 11.9167 9 11.9167Z"
          stroke="currentColor"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.1242 4.87564L11.065 6.93481"
          stroke="currentColor"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.87583 4.87564L6.935 6.93481"
          stroke="currentColor"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.87583 13.1242L6.935 11.065"
          stroke="currentColor"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.1242 13.1242L11.065 11.065"
          stroke="currentColor"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_652_337">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(2 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
